import { Instance, types } from "mobx-state-tree";
import { SharedOrgConfig } from "@fidget/common/models/shared/sharedOrgConfig";

const MaintenanceWindow = types.model("MaintenanceWindow", {
  from: types.number,
  to: types.number,
  message: types.string
});

export const ShortOrgConfig = types.compose(
  "ShortOrgConfig",
  SharedOrgConfig,
  types.model({
    welcomeMessage: types.maybe(types.string),
    headerWelcomeMessage: types.maybe(types.string),
    maintenanceWindows: types.array(MaintenanceWindow),
  })
);

export interface IShortOrgConfig extends Instance<typeof ShortOrgConfig> {}
